import * as AccessibleIcon from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

const ArrowLeft: React.FC<SVGProps<SVGSVGElement>> = props => {
  const label = 'arrow-left'
  return (
    <AccessibleIcon.Root label={label}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.70711 6.29289C10.0976 6.68342 10.0976 7.31658 9.70711 7.70711L6.41421 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H6.41421L9.70711 16.2929C10.0976 16.6834 10.0976 17.3166 9.70711 17.7071C9.31658 18.0976 8.68342 18.0976 8.29289 17.7071L3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929L8.29289 6.29289C8.68342 5.90237 9.31658 5.90237 9.70711 6.29289Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon.Root>
  )
}

export default ArrowLeft
